import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Pinboard',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }
      }, ctx.data]),
      [h("line", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10", x1: "9.56", y1: "16.4", x2: "6.03", y2: "22.5" }
      }), h("path", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10", d: "M16.33 4.66l-3.44-1.99c-.95-.55-2.12.31-1.86 1.37.17.71.5 1.2.5 1.2l-3.39 5.87c-1.14-.07-2.32.46-3.18.98-.63.38-.61 1.3.02 1.67l4.57 2.64 4.57 2.64c.64.37 1.44-.08 1.45-.81.02-1-.1-2.29-.73-3.24l3.39-5.87s.59.04 1.28-.17c1.05-.31 1.21-1.75.26-2.3l-3.44-1.99z" }
      }), h("path", {
        attrs: { d: "M13.83 12.65c-.13 0-.26-.03-.37-.1a.742.742 0 0 1-.27-1.02l2.25-3.89c.21-.36.67-.48 1.02-.27.36.21.48.67.27 1.02l-2.25 3.89c-.14.23-.39.37-.65.37z" }
      }), h("line", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10", x1: "8.14", y1: "11.11", x2: "14.85", y2: "14.98" }
      })]
    );
  }
};